/*@ngInject*/
const OrganizationBrowserActionRepository = function (baseRepository, organizationUtil, temporaryLoginTokenRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function (organizationType, organizationId) {
        var id = _.isNil(organizationId) ? null : organizationId,
            url = '/rest/Actions',
            config = {
                params: {
                    uri: organizationUtil.getOwnerUri(organizationType, organizationId),
                    registrationIdentifier: !_.isNil(organizationId) ? '/Organization/' + organizationId : null
                }
            };

        return this.get(url, config);
    };

    this.createNewOrganization = function (organizationType) {
        var url = '/rest/Organization/create',
            body = {},
            config = {
                params: {
                    organizationType: organizationType
                }
            };

        return this.post(url, body, config);
    };

    this.importCarrierLOAs = function (file, isMga) {
        let url = '/importLOA/CarrierLOAImportServlet',
            formData = new FormData(),
            config = {
                transformRequest: angular.identity,
                params: {
                    fileName: file.name,
                    size: file.size,
                    isMga: isMga
                },
                // When you assign undefined, the content type defaults to multipart/form-data
                headers: {
                    'Content-Type': undefined
                }
            };

        formData.append('file', file);

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.post(url, formData, config);
        });
    };

    this.exportCarrierLOAs = function (isMga) {
        let url = '/exportLOA/CarrierLOAExportServlet',
            config = {
                params: {
                    isMga: isMga
                }
            };

        return temporaryLoginTokenRepository.getSingleUseToken().then((token) => {
            config.params.t = token;
            return this.get(url, config);
        });
    };

};

angular.module('ums.configuration')
    .service('organizationBrowserActionRepository', OrganizationBrowserActionRepository);
